import { useDocumentHead } from "../lib/document-head.ts";
import { ErrorState } from "./ErrorState.tsx";
import { PageShell } from "./PageShell.tsx";

export function NotFoundScreen() {
  useDocumentHead({ title: "Not found — RestoMag Events", robots: "noindex" });

  return (
    <PageShell>
      <ErrorState title="Event not found" message="Check the link or QR code and try again." />
    </PageShell>
  );
}
